<template>    
    <div>
        <template v-for="(el,kye) in cosmicMenuItems">
            <template v-if="el.is_this_homepage==1">
                <div class="video-bar-text" :key="kye">
                    <div class="position-rel">
                        <div class="vid-bar-text-align" v-html="languageData[el.page_desc]">
                            
                        </div>
                    </div>
                </div>
                <template v-if="el.page_video">
                    <template v-if="el.page_video_includes_frames==1">
                        <div class="video-bar-video" :key="kye+1" v-html="el.page_video"></div>
                    </template>
                    <template v-else>
                        <div class="video-bar-video " :key="kye+'c'">
                            <video class="video-bar-videotag" height="355" controls :poster="el.page_video_thumbnail">
                                <source :src="el.page_video" type="video/mp4">
                                <source src="" type="video/ogg">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </template>
                </template>

                <template v-else-if="el.page_image">
                    <div class="video-bar-video" :key="kye+1">
                        <img :src="el.page_image" alt="" class="cosmicdiv-head-img">
                    </div>
                </template>
            
            </template>
        </template>

    </div>
</template>
<script>

export default {
    name:"CompanyLogo",
    data(){
        return{
            LOCAL_HOST:this.$store.state.LOCAL_HOST,
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            company_name:localStorage.name_company,
            video_bar:true
            
        }
    },
     computed:{
        languageData(){return this.$store.state.languageData;},
        cosmicMenuItems(){
           // for(var m=0;m<this.$store.state.cosmicMenu.length;m++){
            return this.$store.state.cosmicMenu;
        }
    },
    watch: {  
       
    },
    mounted:function(){     
       /*  if(this.$store.state.languageData['logo_site'] !== undefined && this.$store.state.languageData['logo_site'] != "" ){
            this.logo_banner=this.$store.state.languageData['logo_site'];
        } */
        
    }
}
</script>
<style scoped>
.logo_style{
    /* max-width:170px; */
    width:100%;
}
#colorlib-logo-banner{
    margin-bottom: 2em !important;
}
.video-bar-text{
    float: left;
    width:57%;
    height:355px;
    background-image: linear-gradient(to right, #FFFFFF, #F4F4F4, #F4F4F4);
    overflow: hidden;
}
.video-bar-video{
    float: left;
    width: 43%;
    height: 355px;
    background: #000;
}
.position-rel{
    position:relative;
    height: 355px;
}
.vid-bar-text-align{
    width: 98%;
    color: #0F2D59;
    letter-spacing: 0.88px;
    font-size: 44px;
    padding: 0 46px 0 0;
    line-height: 64px;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
.video-bar-videotag{
    width: 100%;
}
.cosmicdiv-head-img{
    height: 355px;
    width: -webkit-fill-available;
    object-fit: cover;
}

@media  (min-width: 768px) and (max-width: 1000px) {
    .video-bar-text{ 
        /* width:100%; */
    }
    .video-bar-video{
        /* width: 100%; */
    }
    .vid-bar-text-align{
        padding: 0 30px 0 0 ;
        font-size: 35px;
        line-height: 50px;        
        letter-spacing: 0.48px;
    }
    
    
}
@media only screen and (max-width: 768px) {
     .video-bar-text{ 
        width:100%;
    }
    .video-bar-video{
        width: 100%;
        height: auto;
        background: unset;
    }
    .vid-bar-text-align{
        padding: 25px 26px 25px 35px;
        font-size: 38px;
        line-height: 40px;
        position: unset;
        -webkit-transform: none;
        transform: none;
        letter-spacing: 0.48px;
    }
    .video-bar-text{
        background-image: linear-gradient(to right, #F4F4F4, #F4F4F4);
        height: auto;
    }
    .position-rel{
        height: auto;
    }
    .video-bar-videotag{
        height: auto;
    }
    .cosmicdiv-head-img{
        height: auto;
    }
}
@media only screen and (max-width: 575px) {
    .video-bar-text{ 
        width:100%;
    }
    .video-bar-video{
        width: 100%;
    }
    .vid-bar-text-align{
        padding: 25px 26px 25px 35px;
        font-size: 28px;
        line-height: 40px;
        position: unset;
        -webkit-transform: none;
        transform: none;
        letter-spacing: 0.48px;
    }
    .video-bar-text{
        background-image: linear-gradient(to right, #F4F4F4, #F4F4F4);
        height: auto;
    }
    .position-rel{
        height: auto;
    }
}

</style>